var currency = (function ( $ ) {

	var $currency_switcher;

	var _init = function () {
		$currency_switcher = $( '.currency-switcher' );

		// Get currency or use default of GBP
		var selected_currency   = $.cookie( 'code_ninjas_wmcs_currency' );

		if ( ! selected_currency ) {
			// No currency set so trigger an update by geolocation
			_geolocate_currency();
		}

		if ( $currency_switcher.length ) {
			_setup_currency_switcher();
		}

		_update_prices_currency( selected_currency );
	};

	var _geolocate_currency = function() {
		var data = {
			action: 'crate_geolocate_currency',
			nonce: ScriptData.crate_geolocate_currency_nonce
		};

		$.get( ScriptData.ajaxurl, data, _geolocate_currency_response );
	};

	var _geolocate_currency_response = function( response ) {
		if ( response.currency ) {
			var new_currency = response.currency;

			$.cookie( 'code_ninjas_wmcs_currency', new_currency, { expires: 30, path: '/' } );

			// Update all prices to use this currency
			_update_prices_currency( new_currency );
		}
	};

	var _update_prices_currency = function ( new_currency ) {
		$( '.price' ).each( function () {
			var prices = $( this ).data( 'prices' );

			if ( prices && new_currency in prices ) {
				$( this ).html( prices[new_currency] );
			}
		} );
	};

	var refresh_prices_currency = function() {
		var selected_currency = $.cookie( 'code_ninjas_wmcs_currency' );

		_update_prices_currency( selected_currency );
	};

	var _setup_currency_switcher = function () {
		$currency_switcher.find( 'a' ).on( 'click', _switch_currency );
	};

	var _switch_currency = function ( e ) {
		e.preventDefault();

		var new_currency = $( this ).data( 'currency' );

		_update_prices_currency( new_currency );

		// Save the currency locally
		$.cookie( 'code_ninjas_wmcs_currency', new_currency, { expires: 30, path: '/' } );

		// Update the currency on the server too
		var data = {
			action: 'crate_switch_currency',
			nonce: ScriptData.crate_switch_currency_nonce,
			currency: new_currency
		};

		$.post( ScriptData.ajaxurl, data, _switch_currency_response );

		// Don't wait for the switch response before reloading
		if ( $currency_switcher.hasClass( 'reload' ) ) {
			window.location.reload(true);
		}
	};

	var _switch_currency_response = function ( response ) {
		if ( response.success ) {
			// switched
		}
	};

	$( document ).ready( _init );

	return {
		refresh_prices_currency : refresh_prices_currency
	};

})( jQuery );

module.exports = currency;